import { useState } from 'react'

import PropTypes from 'prop-types'

import { usePrinter } from '../../../hooks/usePrinter'

import SuccessfulShipmentModalView, {
  PRINTER_SERVICE_NOT_INSTALLED_ERROR,
  PRINTER_SERVICE_NOT_CONFIGURED_ERROR,
} from './View'

import { useShippingsLabels } from '../../../services/shippingsLabels'
import { downloadShippingLabel } from '../../business'
import ModalLayout from '../../../ui/modals/layout'
import { Button } from '@mui/material'
import useTranslations from '../../../i18n/useTranslations'

const propTypes = {
  isOpen: PropTypes.bool,
  onCloseClick: PropTypes.func,
  shippingCode: PropTypes.string,
  onNewShippingClick: PropTypes.func,
  onGoBackHome: PropTypes.func,
}

const SuccessfulShipmentModal = ({
  isOpen,
  onCloseClick,
  shippingCode,
  onNewShippingClick,
  onGoBackHome,
}) => {
  const [hasDownloadBeenRequested, setHasDownloadBeenRequested] =
    useState(false)

  const [printerServiceError, setPrinterServiceError] = useState(undefined)

  const [hasPrintBeenRequested, setHasPrintBeenRequested] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)

  const onSuccessDownloadCallback = data => {
    downloadShippingLabel(data)
    setHasDownloadBeenRequested(false)
  }

  const onSuccessPrintCallback = data => {
    console.log(222)
    setShowSuccessModal(true)
    printData(data)
    setHasPrintBeenRequested(false)
  }

  const shippingsToDownload = hasDownloadBeenRequested ? [shippingCode] : []
  const shippingsToPrint = hasPrintBeenRequested ? [shippingCode] : []

  const {
    isWorking: isPrinterServiceWorking,
    modelType,
    printData,
    printer,
    printPosition,
  } = usePrinter()

  useShippingsLabels(
    shippingsToPrint,
    modelType,
    printPosition,
    onSuccessPrintCallback,
  )
  useShippingsLabels(
    shippingsToDownload,
    modelType,
    printPosition,
    onSuccessDownloadCallback,
  )

  const printLabel = () => {
    if (!isPrinterServiceWorking) {
      setPrinterServiceError(PRINTER_SERVICE_NOT_INSTALLED_ERROR)
      return
    }

    if (printer === '') {
      setPrinterServiceError(PRINTER_SERVICE_NOT_CONFIGURED_ERROR)
      return
    }

    setHasPrintBeenRequested(true)
  }

  const downloadLabel = () => {
    setHasDownloadBeenRequested(true)
  }

  const t = useTranslations()

  return (
    <>
      <ModalLayout
        isOpen={showSuccessModal}
        title={t('print-modal:title')}
        content={t('print-modal:body')}
        actions={
          <>
            <Button
              type="button"
              size="small"
              onClick={() => {
                setShowSuccessModal(false)
              }}
            >
              {t('action:close')}
            </Button>
          </>
        }
      />
      <SuccessfulShipmentModalView
        shippingCode={shippingCode}
        isOpen={isOpen && !showSuccessModal}
        close={onCloseClick}
        createNewShipping={onNewShippingClick}
        goBackHome={onGoBackHome}
        printerServiceError={printerServiceError}
        printLabel={printLabel}
        downloadLabel={downloadLabel}
      />
    </>
  )
}

SuccessfulShipmentModal.propTypes = propTypes

export default SuccessfulShipmentModal
